import React, { useEffect } from 'react';
import Input from '@material-ui/core/Input';
import ContainerComponent from './ContainerComponent';
import { SET_VALUE } from '../formReducer';

interface Props {
    value: string;
    formId: string;
    formName: string;
    formDispatch: any;
    autoFocus?: boolean;
    dataTestSc: string;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        type: string;
        description: string;
    };
    readOnly: boolean;
}

const TextFieldComponent: React.FC<Props> = ({
    value,
    formDispatch,
    formId,
    formName,
    autoFocus,
    item: { label, name: fieldId, placeholder, required, subtype, type, description },
    dataTestSc,
    readOnly,
}) => {
    useEffect(() => {
        // Initialize reducer state for both form keys (id and name)
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = ({ target: { value } }: any) => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    };

    return (
        <ContainerComponent label={label} required={required} description={description}>
            {subtype === 'color' ? (
                <input type='color' placeholder={placeholder} onChange={handleChange} data-test-sc={dataTestSc} />
            ) : (
                <Input
                    style={{ width: '100%', fontFamily: "'Google Sans',Roboto,Arial,sans-serif", fontSize: 14 }}
                    placeholder={placeholder}
                    value={value}
                    type={subtype}
                    onChange={handleChange}
                    {...(type === 'textarea' ? { multiline: true as any, rows: 3 as any } : {})}
                    autoFocus={autoFocus}
                    inputProps={{ 'data-test-sc': dataTestSc }}
                    disabled={readOnly}
                />
            )}
        </ContainerComponent>
    );
};

export default TextFieldComponent;
